var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconResetpasswords(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "leftmenu/my/icon-resetpasswords") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "1.33055874e-13%",
    x2: "50%",
    y2: "104.53891%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222222",
    stopOpacity: 0.7,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222222",
    stopOpacity: 0.995478029,
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222222",
    stopOpacity: 0.995478029,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.95,3 C16.065,3 18.6,5.56330314 18.6,8.71308195 L18.6,10.6292395 C20.3,10.84664 21.62,12.2471034 21.73,13.9964188 L23.265,13.9964188 C25.875,13.9964188 28,16.1451443 28,18.7893406 C28,21.4385928 25.875,23.5873183 23.265,23.5873183 L21.73,23.5873183 C21.61,25.4883084 20.065,27 18.15,27 L6.605,27 C4.615,27 3,25.3669686 3,23.3547504 L3,14.2289867 C3,12.3734991 4.375,10.8567516 6.15,10.6292395 L6.15,8.71308195 C6.15,5.56330314 8.685,3 11.8,3 Z M23.265,16.2867074 L9.83,16.2867074 C8.465,16.2867074 7.355,17.4091005 7.355,18.7893406 C7.355,20.1746366 8.465,21.2970297 9.83,21.2970297 L23.265,21.2970297 C24.63,21.2970297 25.74,20.1746366 25.74,18.7994523 C25.74,17.4091005 24.63,16.2867074 23.265,16.2867074 Z M11.92,17.3383189 C12.7125286,17.3383189 13.355,17.9879635 13.355,18.7893406 C13.355,19.5907178 12.7125286,20.2403623 11.92,20.2403623 C11.1274714,20.2403623 10.485,19.5907178 10.485,18.7893406 C10.485,17.9879635 11.1274714,17.3383189 11.92,17.3383189 Z M16.55,17.3383189 C17.3425286,17.3383189 17.985,17.9879635 17.985,18.7893406 C17.985,19.5907178 17.3425286,20.2403623 16.55,20.2403623 C15.7574714,20.2403623 15.115,19.5907178 15.115,18.7893406 C15.115,17.9879635 15.7574714,17.3383189 16.55,17.3383189 Z M21.175,17.3383189 C21.9675286,17.3383189 22.61,17.9879635 22.61,18.7893406 C22.61,19.5907178 21.9675286,20.2403623 21.175,20.2403623 C20.3824714,20.2403623 19.74,19.5907178 19.74,18.7893406 C19.74,17.9879635 20.3824714,17.3383189 21.175,17.3383189 Z M12.95,5.28017695 L11.8,5.28017695 C9.93,5.28017695 8.41,6.81714767 8.41,8.70802612 L8.41,10.5786813 L16.34,10.5786813 L16.34,8.70802612 C16.34,6.81714767 14.82,5.28017695 12.95,5.28017695 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-16.0%",
    y: "-8.3%",
    width: "132.0%",
    height: "133.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.05 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "leftmenu/my/icon-resetpasswords",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconResetpasswords);
export default __webpack_public_path__ + "static/media/icon-resetpasswords.2b0e48f37aeb59897c97bbd067f937bd.svg";
export { ForwardRef as ReactComponent };